import { useUser } from "./useUser";
import { useEntities } from "./useEntities";

export function useOnboardingStatus() {
    const user = useUser();
    const entities = useEntities({
        onlyBusiness: true,
        excludeEmptyMockEntities: true,
    });
    return (
        Boolean(user?.onboardingComplete) &&
        entities.every((e) => e.onboardingComplete)
    );
}
